module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L6X5LR.4d3a0d7a.jpg";